@if (!mixedMode()) {
<!-- Date Filter Section — hidden in My Dashboard mixed embed (parent supplies the global picker). -->
<div class="relative z-[99] mb-6 flex flex-wrap items-center justify-between gap-4">
    <app-date-picker
        [allowComparison]="false"
        [showComparison]="false"
        [showGroupBy]="false"
        placeholder="Select date range"
        variant="outline"
        size="md"
        (dateRangeChange)="onDateRangeChange($event)"
        class="inline-block">
    </app-date-picker>
    <button
        type="button"
        (click)="openCustomizeLayout()"
        class="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg>
        Customize layout
    </button>
</div>
}

<ng-template #sectionPin let-sectionId>
    @if (!mixedMode()) {
    <button
        type="button"
        (click)="addToCustomDashboard(sectionId); $event.stopPropagation()"
        [disabled]="isAddingToCustomDashboard(sectionId)"
        class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
        [ngClass]="isAddedToCustomDashboard(sectionId)
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 !opacity-100 !translate-y-0'
            : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 dark:bg-slate-800/95 dark:border-purple-500/40'"
        [title]="isAddedToCustomDashboard(sectionId) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
        @if (isAddingToCustomDashboard(sectionId)) {
            <svg class="animate-spin shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
            </svg>
            <span>{{ isAddedToCustomDashboard(sectionId) ? 'Removing' : 'Adding' }}&hellip;</span>
        } @else if (isAddedToCustomDashboard(sectionId)) {
            <!-- Pinned state: compact green check at rest so the card title
                 stays fully visible. Hovering morphs the pill open and flips
                 the affordance to a remove minus + label. -->
            <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 6 9 17l-5-5"/>
            </svg>
            <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"/>
            </svg>
            <span class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove from Custom Dashboard</span>
        } @else {
            <!-- Not-pinned state: pill hidden at card-rest. On card hover it
                 fades in as a compact "+" icon. Hovering the icon then morphs
                 the pill open to reveal the label, so the card title is never
                 obscured at rest. -->
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"/><path d="M12 5v14"/>
            </svg>
            <span class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin to Custom Dashboard</span>
        }
    </button>
    }
</ng-template>

<!-- Dashboard Grid — 12-col layout synced with Customize Layout editor -->
<div class="grid grid-cols-12 gap-6 grid-flow-row-dense" [class.h-full]="mixedMode()">

    @if (showSection(SectionId.BUSINESS_GROWTH)) {
    @if(businessGrowth) {
    <!-- Business Growth -->
    <div class="card-bg rounded-2xl p-6 hover:shadow-xl flex flex-col relative group"
        [ngClass]="sectionShellHeightClass()"
        [ngClass]="getSectionColClass(SectionId.BUSINESS_GROWTH)"
        [style.order]="sectionOrder(SectionId.BUSINESS_GROWTH)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.BUSINESS_GROWTH }"></ng-container>
        <div class="flex items-center justify-between mb-4">
            <div>
                <h3 class="text-xl font-medium text-slate-900 dark:text-slate-100">Business Growth</h3>
                <div class="text-sm text-slate-600 dark:text-slate-300">Growth statistics</div>
            </div>
        </div>

        <div class="flex-1 overflow-y-auto scrollbar-theme space-y-3">
            <div class="flex items-center justify-between py-2 px-3 rounded-lg bg-slate-50/50 dark:bg-slate-700/30 hover:bg-slate-100/50 dark:hover:bg-slate-700/50 transition-colors" *ngFor="let stat of businessGrowth">
                <span class="text-sm font-medium text-slate-700 dark:text-slate-300">{{stat.label}}</span>
                <span class="text-sm font-bold text-slate-900 dark:text-slate-100">{{stat.value}}</span>
            </div>
        </div>
          @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
    </div>
    }@else{
    <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl p-6 text-center"
        [ngClass]="getSectionColClass(SectionId.BUSINESS_GROWTH)"
        [style.order]="sectionOrder(SectionId.BUSINESS_GROWTH)">
        <h1 class="text-lg font-medium text-red-800 dark:text-red-200">Business Growth Data not found!!</h1>
    </div>
    }
    }

    @if (showSection(SectionId.ACTIVATION_AND_CALLS)) {
    <!-- Activation & Calls -->
    @if(activationAndCalls){
    <div class="card-bg rounded-2xl p-6 hover:shadow-xl flex flex-col relative group"
        [ngClass]="sectionShellHeightClass()"
        [ngClass]="getSectionColClass(SectionId.ACTIVATION_AND_CALLS)"
        [style.order]="sectionOrder(SectionId.ACTIVATION_AND_CALLS)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.ACTIVATION_AND_CALLS }"></ng-container>
        <div class="flex items-center justify-between mb-4">
            <div>
                <h3 class="text-xl font-medium text-slate-900 dark:text-slate-100">Activation & Calls</h3>
                <div class="text-sm text-slate-600 dark:text-slate-300">Call activity statistics</div>
            </div>
        </div>

        <div class="flex-1 overflow-y-auto scrollbar-theme space-y-3">
            <div class="flex items-center justify-between py-2 px-3 rounded-lg bg-slate-50/50 dark:bg-slate-700/30 hover:bg-slate-100/50 dark:hover:bg-slate-700/50 transition-colors" *ngFor="let stat of activationAndCalls">
                <span class="text-sm font-medium text-slate-700 dark:text-slate-300">{{stat.label}}</span>
                <span class="text-sm font-bold text-slate-900 dark:text-slate-100">{{stat.value}}</span>
            </div>
        </div>
            @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
    </div>
    } @else {
    <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl p-6 text-center"
        [ngClass]="getSectionColClass(SectionId.ACTIVATION_AND_CALLS)"
        [style.order]="sectionOrder(SectionId.ACTIVATION_AND_CALLS)">
        <h1 class="text-lg font-medium text-red-800 dark:text-red-200">Activation and Calls Data not found!!</h1>
    </div>
    }
    }

    @if (showSection(SectionId.PRODUCT_USAGE)) {
    <!-- Product Usage -->
    @if(productUsage){
    <div class="card-bg rounded-2xl p-6 hover:shadow-xl flex flex-col relative group"
        [ngClass]="sectionShellHeightClass()"
        [ngClass]="getSectionColClass(SectionId.PRODUCT_USAGE)"
        [style.order]="sectionOrder(SectionId.PRODUCT_USAGE)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.PRODUCT_USAGE }"></ng-container>
        <div class="flex items-center justify-between mb-4">
            <div>
                <h3 class="text-xl font-medium text-slate-900 dark:text-slate-100">Product Usage</h3>
                <div class="text-sm text-slate-600 dark:text-slate-300">Product Usage statistics</div>
            </div>
        </div>

        <div class="flex-1 overflow-y-auto scrollbar-theme space-y-3">
            <div class="flex items-center justify-between py-2 px-3 rounded-lg bg-slate-50/50 dark:bg-slate-700/30 hover:bg-slate-100/50 dark:hover:bg-slate-700/50 transition-colors" *ngFor="let stat of productUsage">
                <span class="text-sm font-medium text-slate-700 dark:text-slate-300">{{stat.label}}</span>
                <span class="text-sm font-bold text-slate-900 dark:text-slate-100">{{stat.value}}</span>
            </div>
        </div>
            @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
    </div>
    } @else {
    <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl p-6 text-center"
        [ngClass]="getSectionColClass(SectionId.PRODUCT_USAGE)"
        [style.order]="sectionOrder(SectionId.PRODUCT_USAGE)">
        <h1 class="text-lg font-medium text-red-800 dark:text-red-200">Product Usage Data not found!!</h1>
    </div>
    }
    }

    @if (showSection(SectionId.MONETIZATION_REVENUE)) {
    <!-- Monetization & Revenue -->
    @if(memorizationAndRevenue){
    <div class="card-bg rounded-2xl p-6 hover:shadow-xl flex flex-col relative group"
        [ngClass]="sectionShellHeightClass()"
        [ngClass]="getSectionColClass(SectionId.MONETIZATION_REVENUE)"
        [style.order]="sectionOrder(SectionId.MONETIZATION_REVENUE)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.MONETIZATION_REVENUE }"></ng-container>
        <div class="flex items-center justify-between mb-4">
            <div>
                <h3 class="text-xl font-medium text-slate-900 dark:text-slate-100">Monetization & Revenue</h3>
                <div class="text-sm text-slate-600 dark:text-slate-300">Monetization & Revenue statistics</div>
            </div>
        </div>

        <div class="flex-1 overflow-y-auto scrollbar-theme space-y-3">
            <div class="flex items-center justify-between py-2 px-3 rounded-lg bg-slate-50/50 dark:bg-slate-700/30 hover:bg-slate-100/50 dark:hover:bg-slate-700/50 transition-colors" *ngFor="let stat of memorizationAndRevenue">
                <span class="text-sm font-medium text-slate-700 dark:text-slate-300">{{stat.label}}</span>
                <span class="text-sm font-bold text-slate-900 dark:text-slate-100">{{stat.value}}</span>
            </div>
        </div>
            @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
    </div>
    } @else {
    <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl p-6 text-center"
        [ngClass]="getSectionColClass(SectionId.MONETIZATION_REVENUE)"
        [style.order]="sectionOrder(SectionId.MONETIZATION_REVENUE)">
        <h1 class="text-lg font-medium text-red-800 dark:text-red-200">Monetization & Revenue Data not found!!</h1>
    </div>
    }
    }

    @if (showSection(SectionId.PLAN_LIFECYCLE)) {
    <!-- Plan Lifecycle -->
    @if(planLifeCycle){
    <div class="card-bg rounded-2xl p-6 hover:shadow-xl flex flex-col relative group"
        [ngClass]="sectionShellHeightClass()"
        [ngClass]="getSectionColClass(SectionId.PLAN_LIFECYCLE)"
        [style.order]="sectionOrder(SectionId.PLAN_LIFECYCLE)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.PLAN_LIFECYCLE }"></ng-container>
        <div class="flex items-center justify-between mb-4">
            <div>
                <h3 class="text-xl font-medium text-slate-900 dark:text-slate-100">Plan Lifecycle</h3>
                <div class="text-sm text-slate-600 dark:text-slate-300">Plan Lifecycle statistics</div>
            </div>
        </div>

        <div class="flex-1 overflow-y-auto scrollbar-theme space-y-3">
            <div class="flex items-center justify-between py-2 px-3 rounded-lg bg-slate-50/50 dark:bg-slate-700/30 hover:bg-slate-100/50 dark:hover:bg-slate-700/50 transition-colors" *ngFor="let stat of planLifeCycle">
                <span class="text-sm font-medium text-slate-700 dark:text-slate-300">{{stat.label}}</span>
                <span class="text-sm font-bold text-slate-900 dark:text-slate-100">{{stat.value}}</span>
            </div>
        </div>
            @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
    </div>
    } @else {
    <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl p-6 text-center"
        [ngClass]="getSectionColClass(SectionId.PLAN_LIFECYCLE)"
        [style.order]="sectionOrder(SectionId.PLAN_LIFECYCLE)">
        <h1 class="text-lg font-medium text-red-800 dark:text-red-200">Plan Lifecycle Data not found!!</h1>
    </div>
    }
    }

    @if (showSection(SectionId.DISPUTES)) {
    <!-- disputes -->
    @if(disputes){
    <div class="card-bg rounded-2xl p-6 hover:shadow-xl flex flex-col relative group"
        [ngClass]="sectionShellHeightClass()"
        [ngClass]="getSectionColClass(SectionId.DISPUTES)"
        [style.order]="sectionOrder(SectionId.DISPUTES)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.DISPUTES }"></ng-container>
        <div class="flex items-center justify-between mb-4">
            <div>
                <h3 class="text-xl font-medium text-slate-900 dark:text-slate-100">Disputes</h3>
                <div class="text-sm text-slate-600 dark:text-slate-300">Disputes statistics</div>
            </div>
        </div>

        <div class="flex-1 overflow-y-auto scrollbar-theme space-y-3">
            <div class="flex items-center justify-between py-2 px-3 rounded-lg bg-slate-50/50 dark:bg-slate-700/30 hover:bg-slate-100/50 dark:hover:bg-slate-700/50 transition-colors" *ngFor="let stat of disputes">
                <span class="text-sm font-medium text-slate-700 dark:text-slate-300">{{stat.label}}</span>
                <span class="text-sm font-bold text-slate-900 dark:text-slate-100">{{stat.value}}</span>
            </div>
        </div>
            @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
    </div>
    } @else {
    <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl p-6 text-center"
        [ngClass]="getSectionColClass(SectionId.DISPUTES)"
        [style.order]="sectionOrder(SectionId.DISPUTES)">
        <h1 class="text-lg font-medium text-red-800 dark:text-red-200">Disputes Data not found!!</h1>
    </div>
    }
    }
</div>

<app-dashboard-layout-editor
  [open]="isLayoutEditorOpen()"
  [items]="editorItems()"
  [visibleCount]="editorVisibleCount()"
  (closed)="closeLayoutEditor()"
  (applied)="applyLayoutEditor()"
  (resetDefaults)="resetLayoutEditorToDefaults()"
  (cardDropped)="onEditorCardDrop($any($event))"
  (visibilityToggled)="toggleEditorCardVisibility($any($event))"
  (colSpanDecreased)="decreaseEditorCardColSpan($any($event))"
  (colSpanIncreased)="increaseEditorCardColSpan($any($event))"
  (autoAdjustWidth)="autoAdjustEditorWidths()"
/>
